import React, { useEffect } from 'react'
import { Box, Button, Grid } from '@mui/material'
import { PageHeader, LeadSentence } from '../components'
import { scrollTop } from '../modules/util'

interface Props {
  title: string
}

/**
 * 配達日変更受付サービス（完了）
 */
const CompletePage: React.FC<Props> = (props) => {
  const { title } = props

  // ページの先頭にスクロール
  useEffect(() => scrollTop, [])

  return (
    <Box>
      <PageHeader title={title} />

      <Grid container className='content-wrapper'>
        <Grid item xs={12} md={8} lg={6} className='content'>

          <LeadSentence>
            <>
              ご希望内容を承りました。<br />
              ご利用ありがとうございました。
            </>
          </LeadSentence>

          {/* 閉じる */}
          <Box>
            <Grid container
              sx={{
                mt: 4,
                mb: 1,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Grid item xs={12} md={4}>
                <Button
                  size='large'
                  variant='outlined'
                  fullWidth
                  onClick={() => { window.close() }}
                >閉じる</Button>
              </Grid>
            </Grid>
          </Box>

        </Grid>
      </Grid>

    </Box>
  )
}

export default CompletePage
